import { createEducationalAssignmentPdf } from "../helpers/educational-assignment-pdf";

export default {
  methods: {
    async buildAssignmentAnswerPdf(assignmentId, materialId, { includeAssignmentLink = true } = {}) {
      const reportResponse = await this.$api.getAnswerReport(assignmentId, materialId);
      if (this.$handleResponse && !this.$handleResponse(reportResponse)) return null;
      const report = reportResponse.data.payload;
      return createEducationalAssignmentPdf({
        ...report,
        link: includeAssignmentLink ? report.link : undefined,
      });
    },

    async createAssignmentAnswerLink(materialId, expirationDays) {
      try {
        const pdfAttachment = await this.buildAssignmentAnswerPdf(undefined, materialId);
        if (!pdfAttachment) return null;
        const response = await this.$api.createAnswerPdfLink(materialId, { ...pdfAttachment, expirationDays });
        if (this.$handleResponse && !this.$handleResponse(response)) return null;
        return response.data.payload;
      } catch (error) {
        this.$handleError(error);
        return null;
      }
    },

    async sendAssignmentAnswer({ assignmentId }) {
      try {
        const pdfAttachment = await this.buildAssignmentAnswerPdf(assignmentId, undefined, {
          includeAssignmentLink: false,
        });
        if (!pdfAttachment) return false;
        const response = await this.$api.shareAnswer(assignmentId, pdfAttachment);
        if (this.$handleResponse && !this.$handleResponse(response)) return false;
        this.$toastr("success", "Answer shared successfully!");
        return true;
      } catch (error) {
        this.$handleError(error);
        return false;
      }
    },
  },
};
